import { TranslateService } from '@ngx-translate/core';
import { Link } from '@siemens/element-ng/link';

export function getFooterLinks(translate: TranslateService): Link[] {
    return [
        {
            target: '_blank',
            href: 'https://www.siemens.com/corp/en/index/corporate_info.htm',
            title: translate.instant('corporateInfo')
        },
        {
            target: '_blank',
            href: 'https://www.siemens.com/corp/en/index/privacy.htm',
            title: translate.instant('privacyPolicy')
        },
        {
            target: '_blank',
            href: 'https://www.siemens.com/corp/en/index/siemens_ag_cookie_policy.htm',
            title: translate.instant('cookiePolicy')
        },
        {
            target: '_blank',
            href: 'https://www.siemens.com/corp/en/index/terms_of_use.htm',
            title: translate.instant('termsOfUse')
        },
        {
            target: '_blank',
            href: 'https://www.siemens.com/corp/en/index/digital_id.htm',
            title: translate.instant('digitalId')
        },
        {
            target: '_blank',
            href: 'https://gms.siemens.cloud/',
            title: 'powered by /GMS/'
        }
    ];
}
